export const createNativeMediaElementAudioSourceNode = (nativeAudioContext, options) => {
    return nativeAudioContext.createMediaElementSource(options.mediaElement);
};
//# sourceMappingURL=native-media-element-audio-source-node.js.map